// extracted by mini-css-extract-plugin
export default {"key-value-table":"OrderPage_key-value-table__iH836","order-line":"OrderPage_order-line__WdZfI","line-label":"OrderPage_line-label__kC33S"};